<script setup>
defineProps({
  modelValue: { type: String, default: "" },
  disabled: Boolean,
  labelId: { type: String, required: true },
});
const emit = defineEmits(["update:modelValue"]);
const prepare = editor => {
  editor.root.setAttribute("role", "textbox");
  editor.root.setAttribute("aria-multiline", "true");
};
</script>

<template>
  <div :id="labelId + '-editor'" class="social-fund-message-editor">
    <QuillEditor :content="modelValue" content-type="html" theme="snow" :read-only="disabled" :enable="!disabled"
      :options="{ bounds: '#' + labelId + '-editor' }"
      @update:content="value => emit('update:modelValue', value)"
      @ready="editor => { prepare(editor); editor.root.setAttribute('aria-labelledby', labelId); }" />
  </div>
</template>

<style scoped>
.social-fund-message-editor { min-width: 0; width: 100%; }
.social-fund-message-editor :deep(.ql-toolbar) { display: flex; flex-wrap: wrap; font-size: 12px; border-radius: 20px 20px 0 0; }
.social-fund-message-editor :deep(.ql-container) { border-radius: 0 0 20px 20px; }
/* Keep link editing/preview inside each editor, including narrow mobile cards. */
.social-fund-message-editor :deep(.ql-tooltip) { max-width: 100%; white-space: normal; }
.social-fund-message-editor :deep(.ql-tooltip input[type="text"]) { width: 100%; min-width: 0; margin: 4px 0; }
.social-fund-message-editor :deep(.ql-tooltip a.ql-preview) { max-width: 100%; }
.social-fund-message-editor :deep(.ql-editor) { border-radius: inherit; }
.social-fund-message-editor :deep(.ql-editor) {
  font-size: 13px;
  min-height: 86px;
  padding: 12px 16px;
  overflow-wrap: anywhere;
}
.social-fund-message-editor :deep(.ql-editor :where(p, ul, ol, li, b, strong, em, i, u, s, a, span:not(.ql-size-small):not(.ql-size-large):not(.ql-size-huge))) { font-size: inherit; }
</style>
